var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('CentralItemsContainer',_vm._l((_vm.arrayTeamsBySeason),function(team){return _c('TeamItem',{key:team.id,attrs:{"team":team},on:{"click":_vm.onTeamItemClicked}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }